import { Logout, FetchCustomerProfile } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { CustomerState } from './types'

const getInitialState = (): CustomerState => ({
  customerProfile: null,
})

export const customerReducer = (
  state: CustomerState = getInitialState(),
  action: Action<any>,
): CustomerState => {
  switch (action.type) {
    case FetchCustomerProfile.type.SUCCESS:
      return {
        ...state,
        customerProfile: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
